"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _swr = _interopRequireDefault(require("swr"));
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _LanguageProvider = require("../../common/LanguageProvider");
var useProductsFromCollection = function useProductsFromCollection(collectionId, pageSize, fetchedCollection, page) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([collectionId, pageSize, language, page, "useProductsFromCollection"], _fetcher["default"], {
    initialData: fetchedCollection
  });
};
var _default = useProductsFromCollection;
exports["default"] = _default;